<a mat-button
   id="sso-login-button"
   href="/auth/account/external-login/sso-options">
  @if ((lastSsoProvider && lastSsoProvider !== 'Epic') && challengeUrl) {
    Try another SSO
  } @else {
    Log in with SSO
  }
</a>